import AuthService from './common/services/auth/auth.service';

export default function($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('app', {
    abstract: true,
    resolve: {
      authorize: [
        'authService',
        (authService: AuthService) => {
          if(!!localStorage.getItem('showInApp')){
            return authService.authorize(true);
          } else{
            return authService.authorize();
          }
        }
      ]
    }
  });

  $stateProvider.state('mainWrapper', {
    abstract: true,
    component: 'mainWrapper',
    parent: 'app'
  });

  $urlRouterProvider.otherwise('/');
}



// WEBPACK FOOTER //
// ./src/app/app.routes.ts